// src/components/Landing/Services.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { ServerCog, ShieldCheck, Boxes } from 'lucide-react';

const services = [
  {
    title: 'Custom CMS Development',
    desc: 'Full CMS platforms built to your workflows — not templates. Flexible, scalable, and business-first.',
    icon: <ServerCog className="w-6 h-6 text-amber-300" />,
  },
  {
    title: 'Maintenance & Support',
    desc: 'Dedicated support with updates, uptime monitoring, performance tuning, and content management help.',
    icon: <ShieldCheck className="w-6 h-6 text-amber-300" />,
  },
  {
    title: 'Integrations',
    desc: 'Seamless connections with Odoo ERP, payment gateways, notifications, analytics & more.',
    icon: <Boxes className="w-6 h-6 text-amber-300" />,
  },
];

export const Services = () => {
  return (
    <div className="grid gap-8 md:grid-cols-3">
      {services.map((s, i) => (
        <motion.div
          key={s.title}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.1, duration: 0.4 }}
          viewport={{ once: true }}
          whileHover={{ y: -6, scale: 1.02 }}
          className="p-6 rounded-2xl shadow-xl border border-white/10
                     bg-white/10 backdrop-blur-lg dark:bg-white/5
                     transition-all cursor-pointer"
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/10 mb-4 border border-white/10">
            {s.icon}
          </div>

          <h4 className="font-semibold text-lg text-slate-900 dark:text-white mb-2">{s.title}</h4>

          <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed mb-2">
            {s.desc}
          </p>
        </motion.div>
      ))}
    </div>
  );
};
